export function formJsonToText(formJson) {
  try {
    // Parse the JSON if it's a string
    let parsedJson;
    if (typeof formJson === "string") {
      try {
        // Remove any extra escaping if present
        const cleanJsonString = formJson.replace(/\\"/g, '"');
        parsedJson = JSON.parse(cleanJsonString);
      } catch (parseError) {
        console.error("JSON parse error:", parseError);
        return "Invalid JSON string provided";
      }
    } else {
      parsedJson = formJson;
    }

    // Validate we have an array
    if (!Array.isArray(parsedJson)) {
      console.error("Expected array, got:", typeof parsedJson, parsedJson);
      return "Input must be an array of tabs";
    }

    let outputLines = [];

    for (const tab of parsedJson) {
      if (!tab || typeof tab !== "object") continue;

      // Add tab label if exists
      if (tab.label && typeof tab.label === "string") {
        outputLines.push(`\n=== ${tab.label.trim()} ===`);
      }

      // Process content if it exists
      if (Array.isArray(tab.content)) {
        // Group fields by sections
        const sections = [];
        let currentSection = { subtitle: null, fields: [] };

        for (const field of tab.content) {
          if (!field || typeof field !== "object") continue;

          // Handle section titles/subtitles
          if (field.select === "Section Subtitle" && field.value) {
            // Save the current section if it has fields
            if (currentSection.fields.length > 0 || currentSection.subtitle) {
              sections.push(currentSection);
            }
            // Start a new section
            currentSection = { subtitle: field.value, fields: [] };
            continue;
          }

          // Process regular fields
          const label =
            field.question && typeof field.question === "string"
              ? field.question.trim()
              : "Untitled Field";

          // Get the answer based on field type with proper validation
          let answer = "";
          let hasValidAnswer = false;

          switch (field.select) {
            case "Short Answer":
            case "Date":
            case "Time":
              if (
                field.answer !== undefined &&
                field.answer !== null &&
                field.answer !== ""
              ) {
                answer = field.answer;
                hasValidAnswer = true;
              } else if (field.value && field.value !== "") {
                answer = field.value;
                hasValidAnswer = true;
              }
              break;

            case "Paragraph":
              if (
                field.answer !== undefined &&
                field.answer !== null &&
                field.answer !== ""
              ) {
                let answerVal = field.answer;

                // If answer is a JSON-looking string with a "summary" key, unwrap it.
                if (
                  typeof answerVal === "string" &&
                  answerVal.trim().startsWith("{")
                ) {
                  try {
                    const parsed = JSON.parse(answerVal);
                    if (
                      parsed &&
                      typeof parsed === "object" &&
                      typeof parsed.summary === "string"
                    ) {
                      answerVal = parsed.summary;
                    }
                  } catch (_) {
                    // ignore parse error, keep original
                  }
                }

                answer = answerVal;
                hasValidAnswer = true;
              } else if (field.value && field.value !== "") {
                answer = field.value;
                hasValidAnswer = true;
              }
              break;

            case "Checkboxes":
            case "Multiple Choice":
              if (Array.isArray(field.answer) && field.answer.length > 0) {
                const validAnswers = field.answer
                  .map((a) => (a && a.value ? a.value : ""))
                  .filter((val) => val);
                if (validAnswers.length > 0) {
                  answer = validAnswers.join(", ");
                  hasValidAnswer = true;
                }
              } else if (field.value && field.value !== "") {
                answer = field.value;
                hasValidAnswer = true;
              }
              break;

            default:
              if (
                field.answer !== undefined &&
                field.answer !== null &&
                field.answer !== ""
              ) {
                answer = field.answer;
                hasValidAnswer = true;
              } else if (field.value && field.value !== "") {
                answer = field.value;
                hasValidAnswer = true;
              }
          }

          // Only add if we have a valid label and a non-empty answer
          if (label && hasValidAnswer && answer.trim() !== "") {
            currentSection.fields.push(`${label}: ${answer}`);
          }
        }

        // Don't forget the last section
        if (currentSection.fields.length > 0 || currentSection.subtitle) {
          sections.push(currentSection);
        }

        // Now output sections, but only if they have content
        for (const section of sections) {
          if (section.fields.length > 0) {
            if (section.subtitle) {
              outputLines.push(`\n-- ${section.subtitle} --`);
            }
            outputLines.push(...section.fields);
          }
        }
      }
    }

    const result = outputLines.join("\n").trim();
    return result;
  } catch (error) {
    console.error("Conversion error:", error);
    return "Error converting form to text";
  }
}
